import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
//import * as authActions from 'app/auth/store/actions';
import React, { useState, useEffect, useCallback  } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Divider, Badge } from '@material-ui/core';
import clsx from 'clsx';
//import { getUserData } from 'app/auth/store/actions'
import {socket} from 'context/socket';
import {useTranslation} from 'react-i18next';
import LanguageSwitcher from '../shared-components/LanguageSwitcher';
import Hidden from '@material-ui/core/Hidden';
import { logoutUser } from 'app/auth/store/actions/user.actions.js'
import UserStatus from 'app/main/apps/users/Users';
import * as ActionsMini from 'app/store/actions';
import Tooltip from '@material-ui/core/Tooltip';
import { CiCircleQuestion } from "react-icons/ci";
import IconButton from '@material-ui/core/IconButton';
import { projectSelectAPI, resetGetMembers, resetGetProjects, resetSideMenuItem } from 'app/store/actions';


const StyledBadge = withStyles((theme) => ({
	colorPrimary: {
		backgroundColor: 'green'
	},
	colorSecondary: {
		backgroundColor: 'orange'
	},
	colorError: {
		backgroundColor: 'red'
	},
}))(Badge);


const useStyles = makeStyles((theme) => ({
	infoStatusHidden:{
		fontSize: '28px',
		position: 'absolute',
		top: '-6px',
		right: 0
	},
	popoverStyle:{
		
	},
	iconStatus:{
		position: 'absolute',
		zIndex: 2,
		right: -4,
		bottom: -3,
	},
	status: {
		background: 'green',
		borderRadius: '50px',
		position: 'absolute',
		left: '37px',
		bottom: '12px',
		width: '13px',
		height: '13px',
	},
	typo: {
		fontSize:'1.2rem',
		padding:'0 10px 15px 10px', 
		textAlign: 'left',
		color: theme.palette.scaiPro.textSecondary,
		opacity:'0.7',
	},
	lang:{
		fontSize:'1.2rem',
		padding:'10px', 
		textAlign: 'left',
		color: theme.palette.scaiPro.textSecondary,
		opacity:'0.7',
	},
	menuItemStatus: {
		padding:'0 10px', 
		[theme.breakpoints.down('xs')]:{
			marginBottom:'-10px',
		},
		'&:hover': {
			//backgroundColor: 'grey'
		}
	},
	text: {
		display: 'flex',
		justifyContent: 'flex-end',
		color: theme.palette.scaiPro.title,
	},
	online: {
		backgroundColor: 'green'
	},
	busy: {
		color: 'red'
	},
	absent: {
		color: 'orange'
	},
	invisible: {
		color: 'white'
	}
}));

function UserMenu(props) {
	const {t} = useTranslation('sharedComponentsPage');
	const classes = useStyles();
	const dispatch = useDispatch();
	const connectedUser = useSelector(({ user }) =>  user ? user?.user : JSON.parse(localStorage.getItem('current_user')));
	const [userMenu, setUserMenu] = useState(null);
	const handleCompanyProject = useSelector(({multipleCompanies}) => multipleCompanies.multipleCompanies.handleDetails);
	//const cu = localStorage.getItem("current_user");
	const allUsers = useSelector(({ users }) => users);

	let statusUser = allUsers.users.status.filter(obj => parseInt(obj.id) === connectedUser.id)


	const handleLogout =  useCallback((user) => {
		socket.emit("user_is_logged_out", user)
		dispatch(logoutUser(true));

		dispatch(projectSelectAPI(null));
		dispatch(resetSideMenuItem());
		dispatch(resetGetMembers());
		dispatch(resetGetProjects());
	}, [dispatch])
	  
	useEffect(() => {

		socket.on("check_users_disconnected_success", async (data) => {
			//console.log("check_users_disconnected_success", data)
			if(data.flat().includes(connectedUser.id)){
				console.log(connectedUser.id," has been disconnected due to inactivity")
				handleLogout(connectedUser.id)
			}
	   	})

	}, [handleLogout,connectedUser.id])

	const userMenuClick = event => {
		setUserMenu(event.currentTarget);
	};

	const goToProfile = () => {
		userMenuClose()
		//dispatch(ActionsMini.closeChatPanel())
	}

	const userMenuClose = () => {
		setUserMenu(null);
	};

	const changeUserLoggedStatus = (e) => {
		let _formValues = {
			userId: connectedUser.id,
			reqStatus: e,
			authToken: connectedUser.authToken
		}
		socket.emit("change_user_status", _formValues)
		console.log("changeUserLoggedStatus", e)
		dispatch(ActionsMini.updateUserStatus(e))
		userMenuClose()
	}

	return (
		<>
			<Button className="h-64" onClick={userMenuClick}>
				<StyledBadge overlap="rectangular">
					<div className="absolute right-0 bottom-0 -m-4" style={{right: '2px', bottom: '0px', zIndex: 99}}> 
						<UserStatus user={connectedUser.id} group={false}/>
					</div>
					{connectedUser.profile_image ?
						<Avatar className="" alt={connectedUser.name} src={connectedUser.profile_image} />
						:
						<Avatar className="">{connectedUser.shortName}</Avatar>
					}
				</StyledBadge>
					
				{/*<div className="hidden md:flex flex-col mx-12 items-start">
					<Typography component="span" className="normal-case font-600 flex user-name">
						{connectedUser.name}
					</Typography>
					<Typography className="text-11 capitalize" color="textSecondary">*/}
						{/* {user.grouptype && connectedUser.grouptype.name} */}
						{/*{connectedUser.membertype && connectedUser.membertype.name}
					</Typography>
				</div>*/}

				<Icon className="text-16 hidden sm:flex" variant="action">
					keyboard_arrow_down
				</Icon>
			</Button>

			<Popover
				open={Boolean(userMenu)}
				anchorEl={userMenu}
				onClose={userMenuClose}
				className={classes.popoverStyle}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'center'
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'center'
				}}
				classes={{
					paper: 'py-8'
				}}
			>
				<Hidden mdUp>
					<div className='mb-16'>
						<div className="flex flex-col mx-12 items-center mt-10 mb-20">
							<Typography component="span" className="normal-case font-600 flex user-name">
								{connectedUser.name}
							</Typography>
							<Typography className="text-11 capitalize" color="textSecondary">
								{connectedUser.grouptype && connectedUser.grouptype.name}
							</Typography>
						</div>
						<Hidden smUp>
							<div className={clsx('flex flex-col items-center justify-center mb-16',classes.boxCompanyUserSection)}>
								{handleCompanyProject.companyName !== undefined &&
									handleCompanyProject.companyName
								}
							</div>
						</Hidden>
						<Divider />
					</div>
				</Hidden>

				<Hidden lgUp>
					<div className='-mt-12 mb-16'>
						<div className="flex flex-col">
							<Typography className={classes.lang}>
								{t('language')}
							</Typography>
							<div className="flex flex-col items-center -mt-12">
								<LanguageSwitcher />
							</div>
						</div>
						<Divider />
					</div>
				</Hidden>

				<Typography className={classes.typo}>
					{t('set_status')} {statusUser && statusUser[0] && statusUser[0].userstatus === "calling" && 
					<Tooltip
						title={'Status cannot be updated during call'}
						placement={props.variant === 'horizontal' ? 'bottom' : 'bottom'}
					>
						<IconButton
							aria-owns={null}
							aria-haspopup="true"
							className={classes.infoStatusHidden}
						>
							<CiCircleQuestion /> 
						</IconButton>
					</Tooltip> 
					}
				</Typography>
				
				<MenuItem disabled={statusUser && statusUser[0] && statusUser[0].userstatus === "calling" && true} className={classes.menuItemStatus} onClick={() => changeUserLoggedStatus('online')}>
					<Icon className="block text-16 text-green bg-white rounded-full">check_circle</Icon>
					<ListItemText primary={t("online")} className={classes.text} />
				</MenuItem>
				<MenuItem disabled={statusUser && statusUser[0] && statusUser[0].userstatus === "calling" && true} className={classes.menuItemStatus} onClick={() => changeUserLoggedStatus('busy')}>
					<Icon className="block text-16 text-yellow-700  rounded-full">access_time</Icon>
					<ListItemText primary={t("busy")} className={classes.text} />
				</MenuItem>
				<MenuItem disabled={statusUser && statusUser[0] && statusUser[0].userstatus === "calling" && true} className={classes.menuItemStatus} onClick={() => changeUserLoggedStatus('absent')}>
					<Icon className="block text-16 text-red bg-white rounded-full">remove_circle_outline</Icon>
					<ListItemText primary={t("absent")} className={classes.text} />
				</MenuItem>
				
				<Divider />
				<MenuItem component={Link} to="/dashboard/map" role="button">
					<ListItemIcon className="min-w-40">
						<Icon>home</Icon>
					</ListItemIcon>
					<ListItemText primary={t("home")} />
				</MenuItem>
				<Divider />
				<MenuItem component={Link} to="/profile" role="button" onClick={() => goToProfile()}>
					<ListItemIcon className="min-w-40">
						<Icon>assignment_ind</Icon>
					</ListItemIcon>
					<ListItemText primary={t("my_profile")} />
				</MenuItem>
				<Divider />
				<MenuItem component={Link} to="/" role="button" onClick={() => handleLogout(connectedUser.id)}>
					<ListItemIcon className="min-w-40">
						<Icon>exit_to_app</Icon>
					</ListItemIcon>
					<ListItemText primary={t("logout")} />
				</MenuItem>
			</Popover>
		</>
	);
}

export default UserMenu;
//export default withReducer('chatApp', reducer)(UserMenu);

